import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {

  @Input() id = null;
  @Input() href = null;
  @Input() classname = null;
  
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  onClick(){
    this.router.navigateByUrl(this.href)
    window["$"](`#${this.id}`).tooltip('hide')
  }

}
